export default "__VITE_ASSET__043e200a__"